import React from 'react';
import { Form, Input, message } from 'antd';
import css from './index.module.scss';
import Button from '@/components/UI/Button';
import EfModal from '@/components/UI/Modal';
//import { EFEmail } from '@/components/UI/svg/Footer';
import EFEmail from '@/components/UI/svg/Footer/Icon/EFEmail';
import { createSubscribe } from '@/service';
import { useGlobal } from '@/utils/useGlobal';
import { subscribeCookie } from '@/utils/cookies/subscribeCookie';
import getLocal from '@/app/utils/getLocal';

interface props {
    open: boolean;
    closeModal?: () => void;
    onSuccess?: () => void;
}

interface form {
    email: string;
}

const SubscribeModal: React.FC<props> = ({ open, closeModal, onSuccess }) => {
    const { locale } = getLocal();
    const { useLang, useState, useEffect } = useGlobal();
    const [subscribeForm] = Form.useForm<form>();
    const [submitLoading, setSubmitLoading] = useState(false);
    const [submitDisabled, setSubmitDisabled] = useState(true);
    const [resStatus, setResStatus] = useState({ message: '', pass: true });
    const { t } = useLang('my.MemberShip');
    const { t: ts } = useLang('shared');

    const onSubmit = async (data: form) => {
        try {
            setSubmitLoading(true);
            const { email } = data;
            const res = await createSubscribe({
                email,
                source: 'WEB_CREDITS',
                ...subscribeCookie({
                    entry_name: 'ecocredits floating',
                }),
            });
            if (res?.code === '0') {
                const tips: Record<string, string> = {
                    de: 'Erfolgreich!',
                };
                message.success(tips[locale] || 'Success');
                onSuccess && onSuccess();
                closeModal && closeModal();
            } else {
                setResStatus({ pass: false, message: res.message });
                setTimeout(() => {
                    subscribeForm.validateFields();
                }, 0);
            }
        } catch {
            message.error('System Error');
        } finally {
            setSubmitLoading(false);
        }
    };

    const onValuesChange = (data: form) => {
        setSubmitDisabled(!data?.email);
    };

    useEffect(() => {
        if (!open) {
            subscribeForm.resetFields();
            setSubmitLoading(false);
            setSubmitDisabled(true);
        }
    }, [open]);

    return (
        <EfModal className={css.efmodal} visible={open} onCancel={() => closeModal && closeModal()} zIndex={1200}>
            <h4 className="m-title">{t('subscribe_now')}</h4>
            <Form form={subscribeForm} className="m-form" onFinish={onSubmit} onValuesChange={onValuesChange}>
                <Form.Item
                    name="email"
                    validateFirst
                    rules={[
                        { type: 'email', message: ts('common.email_validation_error') },
                        {
                            validator: () => (resStatus?.pass ? Promise.resolve() : Promise.reject(resStatus.message || '')),
                        },
                    ]}
                >
                    <Input className="cInput" placeholder={t('email_address')} prefix={<EFEmail />} />
                </Form.Item>
                <Form.Item>
                    <Button disabled={submitDisabled} loading={submitLoading} className={`m-submit-btn ${submitDisabled ? 'disabled' : ''}`} htmlType="submit">
                        {t('subscribe_capital_letters')}
                    </Button>
                </Form.Item>
            </Form>
        </EfModal>
    );
};

export default SubscribeModal;
